__turbopack_context__.v({
  "content": "editor-module__GKfaWW__content",
  "root": "editor-module__GKfaWW__root",
  "toolbar": "editor-module__GKfaWW__toolbar",
});
